
   const SocialMediaButtons = () => {
    return (
      

      <div className="share-btn-container">
        <a href="https://api.whatsapp.com/send?phone=8870897752&text=Hi,%20Sarvaa!" className="whatsapp-btn">
          <i className="fab fa-whatsapp"></i>
        </a>
  
        <a href="https://t.me/sarvaatechnologies" className="twitter-btn">
          <i className="fab fa-telegram"></i>
        </a>
        
        <a href="skype:live:.cid.2efc95efb542e68?chat" className="linkedin-btn">
          <i className="fab fa-skype"></i>
        </a>
  
        <a href="mailto:sales@sarvaatechnologies.com" className="facebook-btn">
          <i className="fa-solid fa-envelope"></i>
        </a>

      </div>
      
  );
};

export default SocialMediaButtons;